let DefaultLabelValues = /*#__PURE__*/function (DefaultLabelValues) {
  DefaultLabelValues["DRAG_DROP"] = "Drag and drop the file here, or...";
  DefaultLabelValues["BROWSE"] = "Browse and select the file";
  DefaultLabelValues["REMOVE"] = "Remove";
  DefaultLabelValues["FILE_DETAILS"] = "Max file size 200Kb. Supported files: .xlsx";
  DefaultLabelValues["DROP"] = "Drop the file here";
  return DefaultLabelValues;
}({});

export { DefaultLabelValues };
//# sourceMappingURL=labels.js.map
